import {Box} from '@material-ui/core'
import {listReportFolders} from 'modules/reports/api/reportFolders'
import useCore from 'modules/reports/hooks/core'
import useMount from 'modules/reports/hooks/mount'
import ReportFolder from 'modules/reports/models/ReportFolder'
import authStore from 'modules/reports/stores/auth'
import React from 'react'
import ReportsFolderSidebarAdd from './Add'
import ReportsFolderSidebarItem from './Item'
import ReportsFolderSidebarContext from './ReportsFolderSidebar.context'
import useStyles from './ReportsFolderSidebar.styles'

type Props = {
  className?: string
  folders: ReportFolder[]
  folderId: any
  onSelect: (folder: ReportFolder) => void
  onChange: (folders: ReportFolder[]) => void
}

function ReportsFolderSidebar(props: Props) {
  const classes = useStyles()
  const {p, pt} = useCore('reports', 'components', 'FolderSidebar')
  const {folders, folderId, onSelect, onChange} = props

  const ALL_FOLDER = React.useMemo(
    () =>
      new ReportFolder().set({
        id: 'all',
        name: pt('all-folder'),
      }),
    [pt]
  )

  async function loadFolders() {
    const foldersResponse = await listReportFolders({accountId: authStore.user.account_id})
    onChange([ALL_FOLDER, ...foldersResponse.data])
  }

  function handleSelect(folder?: ReportFolder) {
    if (folder) onSelect(folder)
  }

  function handleCreate(folder: ReportFolder) {
    onChange([...folders, folder])
  }

  function handleEdit(folder: ReportFolder) {}

  function handleDelete(folder: ReportFolder) {
    onChange(folders.filter(f => f !== folder))
    onSelect(folders[0])
  }

  const contextValue = {
    folderId,
    onSelect: handleSelect,
    onCreate: handleCreate,
    onEdit: handleEdit,
    onDelete: handleDelete,
  }

  useMount(() => {
    onChange([ALL_FOLDER])
    loadFolders()
  })

  return (
    <Box className={`${props.className} ${classes.root}`}>
      <ReportsFolderSidebarContext.Provider value={contextValue}>
        {folders.map((folder, index) => (
          <ReportsFolderSidebarItem
            key={folder.id}
            folder={folder}
            data-testid={p(`item-${index}`)}
          />
        ))}

        <ReportsFolderSidebarAdd />
      </ReportsFolderSidebarContext.Provider>
    </Box>
  )
}

export default ReportsFolderSidebar
